import { ChemicalType, ChemicalTypeSalt } from "../types";
import { BowHistoryMixEvents } from "../types";
import Locale from "../utils/Locale"

export function getBowHistoryMixEventsLocalised(eventType: BowHistoryMixEvents): string {
    switch (eventType) {
    case BowHistoryMixEvents.AcidMix: return Locale.gettext("Acid");
    case BowHistoryMixEvents.BaseMix: return Locale.gettext("Base");
    case BowHistoryMixEvents.CO2Mix: return Locale.gettext("CO₂");
    case BowHistoryMixEvents.LiquidChlorineMix: return Locale.gettext("Liquid Chlorine");
    case BowHistoryMixEvents.SaltChlorinatorMix: return Locale.gettext("Salt Chlorination");
    default: return eventType;
    }
}

export function getChemicalTypeByBowHistoryMixEvent(eventType: BowHistoryMixEvents): ChemicalType | typeof ChemicalTypeSalt {
    switch (eventType) {
    case BowHistoryMixEvents.AcidMix: return ChemicalType.MuriaticAcid;
    case BowHistoryMixEvents.BaseMix: return ChemicalType.Base;
    case BowHistoryMixEvents.CO2Mix: return ChemicalType.Co2;
    case BowHistoryMixEvents.LiquidChlorineMix: return ChemicalType.Chlorine;
    case BowHistoryMixEvents.SaltChlorinatorMix: return ChemicalTypeSalt;
    default: return eventType;
    }
}

